module.exports = __webpack_public_path__ + "static/harry-potter-and-the-chamber-of-secrets-3a30df68a21aab82f652b0e1644ff6a6.jpg";